import { render, staticRenderFns } from "./ModalDocument.vue?vue&type=template&id=33ad335e&scoped=true"
import script from "./ModalDocument.vue?vue&type=script&lang=js"
export * from "./ModalDocument.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad335e",
  null
  
)

export default component.exports